import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';
import { apiBase } from '@/utils/apiBase';

const API = apiBase();

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setSessionUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');
      if (!sessionId) {
        navigate('/login');
        return;
      }
      try {
        const res = await axios.get(`${API}/auth/session`, {
          params: { session_id: sessionId },
          withCredentials: true
        });
        setSessionUser(res.data.user, res.data.token);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, setSessionUser]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground text-sm">Signing you in...</p>
      </div>
    </div>
  );
};
